// 20MB
export const SUPPORTED_FILE_SIZE = 20971520;
